import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const ShareableLinkSpaceAdminControlsLoader: LoadableType<{
	spaceKey?: string;
}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ShareableLinkSpaceAdminControls" */ './components/ShareableLinkSpaceAdminControls.tsx'
			)
		).ShareableLinkSpaceAdminControls,
});
